// extracted by mini-css-extract-plugin
export default {"grid":"ResetPassword_grid__kWhbb","section":"ResetPassword_section__uWBMR","content":"ResetPassword_content__I5w3+","account":"ResetPassword_account__2wRDe"};